import React from 'react';

const Header = (props) => {

    return (
        <div className="row">
            <div className="col-xs-1">
                {(props.Impresion == true) && <button className="btn btn-icon" tittle="Imprimir">
                    <span className="ti-printer"></span>
                </button>}
            </div>
            <div className="col-xs-1">
                {(props.Exportacion == true) && <button className="btn btn-icon" title="Exportar">
                    <span className="ti-export"></span>
                </button>}
            </div>
        </div>
    );
}

export default Header;